import React, { Component } from "react";
import AccountFilter from "./Report.AccountFilter";
import SummaryReport from "./Report.SummaryReport";
import DetailsReport from "./Report.DetailsReport";
import MonthlyReport from "./Report.MonthlyReport";
import DayBook from "./Report.DayBookReport";
import ReceiptMulti from "./Report.ReceiptMultiple";
import ChequeReport from "./Report.ChequeReport";

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "Filter",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "Filter") {
      return (
        <AccountFilter
          onClick={this.handleClick}
          reportType={this.props.reportSubType}
        />
      );
    } else if (this.state.mode === "Account Summary") {
      return (
        <SummaryReport data={this.state.data} onCloseClick={this.handleClick} />
      );
    } else if (this.state.mode === "Income Details") {
      this.state.data.txnType = "Income";
      return (
        <DetailsReport data={this.state.data} onCloseClick={this.handleClick} />
      );
    } else if (this.state.mode === "Expense Details") {
      this.state.data.txnType = "Expense";
      return (
        <DetailsReport data={this.state.data} onCloseClick={this.handleClick} />
      );
    } else if (this.state.mode === "Monthly") {
      this.state.data.txnType = "Monthly";
      return (
        <MonthlyReport data={this.state.data} onCloseClick={this.handleClick} />
      );
    } else if (this.state.mode === "DayBook") {
      this.state.data.txnType = "DayBook";
      return <DayBook data={this.state.data} onCloseClick={this.handleClick} />;
    } else if (this.state.mode === "Receipt") {
      this.state.data.txnType = "Receipt/Voucher";
      return (
        <ReceiptMulti data={this.state.data} onCloseClick={this.handleClick} />
      );
    } else if (this.state.mode === "Cheque") {
      this.state.data.txnType = "Cheque Details";
      return (
        <ChequeReport data={this.state.data} onCloseClick={this.handleClick} />
      );
    }
  }

  handleClick(mode, data) {
    this.setState({ mode, data });
  }
}

export default Account;
